var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595 4493 c-290 -62 -519 -294 -579 -585 -14 -68 -16 -229 -16 -1348 0 -1387 -2 -1345 57 -1485 75 -178 230 -333 409 -408 141 -60 38 -57 2094 -57 2033 0 1947 -2 2084 51 172 68 333 223 412 398 62 138 58 41 61 1466 3 1161 2 1308 -12 1379 -60 297 -291 529 -587 590 -69 14 -276 16 -1965 15 -1637 -1 -1897 -3 -1958 -16z m3867 -294 c171 -36 310 -175 347 -347 16 -74 16 -2508 0 -2584 -16 -77 -74 -180 -129 -232 -56 -53 -144 -99 -218 -115 -76 -16 -3729 -16 -3804 0 -172 37 -310 175 -347 347 -16 74 -16 2508 0 2584 18 87 58 158 123 223 64 64 127 100 211 121 68 17 3736 20 3817 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2038 3439 c-23 -12 -46 -35 -58 -59 -20 -38 -20 -58 -20 -820 0 -763 0 -782 20 -820 35 -69 125 -99 193 -64 18 9 305 187 640 396 547 342 609 383 627 418 25 50 25 90 0 140 -18 35 -80 76 -627 418 -335 209 -622 387 -640 396 -42 21 -89 20 -135 -5z m670 -679 c172 -107 312 -197 312 -200 0 -4 -171 -112 -692 -437 l-68 -43 0 480 0 480 68 -43 c37 -23 208 -130 380 -237z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.e23e4307b988a6508c7791d03fb1ea2f.svg";
export { ForwardRef as ReactComponent };